module.exports = __webpack_public_path__ + "static/media/wine-bottle-types.b7148b10.jpg";